
export interface workDef {
  label: string;
  field: string;
  comment?: boolean;
  checker?: boolean;
  subFields?: Array<{label: string, field: string, unit?: string, type?: string}>;
};

export class Check {
  type: string;

  constructor(type: string) {
    this.type = type;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/check/check.class.ts